import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "components/button/Button";
import { capitalize } from "lodash";
import { STATIC_ROUTES } from "Routes";
import { splitIntoArraysOfLengthX } from "utils/arrays";
import * as S from "styles/DraftBoard.styles";
import * as T from "styles/StandardScreen.styles";
import { api } from "utils/api";

export const DraftsHome = () => {
  const { era } = useParams();
  const isReady = useSelector((state) => state?.currentVariables?.isReady);
  const [completedDraftsArray, setCompletedDraftsArray] = useState([]);
  const [futureDraftsArray, setFutureDraftsArray] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const draftData = await api.get("/drafts/list");
      const draft = draftData?.[0] ?? {};
      const { completedDrafts, futureDrafts } = draft;

      setCompletedDraftsArray(splitIntoArraysOfLengthX(completedDrafts, 3));
      setFutureDraftsArray(splitIntoArraysOfLengthX(futureDrafts, 3));
    };

    loadData();
  }, [isReady, era]);

  const buttonTextFunction = useCallback((draftSportYear) => {
    const draftSportYearArray = draftSportYear.split("-");
    const [sport, year] = draftSportYearArray;
    const title =
      year === "startup"
        ? `${capitalize(sport)} ${capitalize(year)}`
        : `${year} ${capitalize(sport)} Supplemental`;

    return {
      title,
      sport,
      year,
    };
  }, []);

  return (
    <T.FlexColumnCenterContainer>
      <T.Title>Drafts Home Page</T.Title>
      <S.DraftsHomeContainer>
        <S.DraftsHeader>Completed Draft Results</S.DraftsHeader>
        {completedDraftsArray.map((row, i) => {
          return (
            <S.DraftsHomeRowContainer key={i}>
              {row.map((draft) => {
                const { title, sport, year } = buttonTextFunction(draft);
                return (
                  <Button
                    key={draft}
                    title={title}
                    navTo={`${STATIC_ROUTES.DynastyHome}/${era}/draft/${sport}/${year}`}
                  />
                );
              })}
            </S.DraftsHomeRowContainer>
          );
        })}
      </S.DraftsHomeContainer>
      <S.DraftsHomeContainer>
        <S.DraftsHeader>{`Future Draft Boards`}</S.DraftsHeader>
        {futureDraftsArray.map((row, i) => {
          return (
            <S.DraftsHomeRowContainer key={i}>
              {row.map((draft) => {
                const { title, sport, year } = buttonTextFunction(draft);
                return (
                  <Button
                    key={draft}
                    title={title}
                    navTo={`${STATIC_ROUTES.DynastyHome}/${era}/draft/${sport}/${year}`}
                  />
                );
              })}
            </S.DraftsHomeRowContainer>
          );
        })}
      </S.DraftsHomeContainer>
    </T.FlexColumnCenterContainer>
  );
};
